var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1104_2319)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.713 8.98665L21.4197 9.51998L15.5397 17.2933L10.8063 10.24L6.57967 16.4266L3.57967 13.76L4.49967 12.7L6.29967 14.2933L10.8063 7.70665L15.5997 14.8466L20.0397 8.97331C19.367 8.91651 18.7129 8.72297 18.1177 8.40456C17.5224 8.08615 16.9983 7.64957 16.5777 7.12156C16.157 6.59354 15.8486 5.98521 15.6712 5.33382C15.4939 4.68243 15.4514 4.0017 15.5463 3.33331H3.16634C2.81272 3.33331 2.47358 3.47379 2.22353 3.72384C1.97348 3.97389 1.83301 4.31302 1.83301 4.66665V19.3333C1.83301 19.6869 1.97348 20.0261 2.22353 20.2761C2.47358 20.5262 2.81272 20.6666 3.16634 20.6666H21.833C22.1866 20.6666 22.5258 20.5262 22.7758 20.2761C23.0259 20.0261 23.1663 19.6869 23.1663 19.3333V8.22665C22.4293 8.6907 21.5833 8.9528 20.713 8.98665Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6663 9.05141V19.3333C22.6663 19.5543 22.5785 19.7663 22.4223 19.9226C22.266 20.0788 22.054 20.1666 21.833 20.1666H3.16634C2.94533 20.1666 2.73337 20.0788 2.57709 19.9226C2.4208 19.7663 2.33301 19.5543 2.33301 19.3333V4.66665C2.33301 4.44563 2.42081 4.23367 2.57709 4.07739C2.73337 3.92111 2.94533 3.83331 3.16634 3.83331H15.0006C14.9807 4.38255 15.0438 4.93276 15.1888 5.46517C15.384 6.18222 15.7235 6.85187 16.1866 7.43311C16.6497 8.01435 17.2265 8.49495 17.8818 8.84545C18.2815 9.05922 18.7052 9.22186 19.1429 9.33041L15.6238 13.9856L11.2215 7.42796L10.8103 6.81545L10.3937 7.4243L6.20691 13.5434L4.83108 12.3256L4.45302 11.9909L4.12207 12.3722L3.20207 13.4322L2.87818 13.8054L3.24749 14.1337L6.24749 16.8004L6.67207 17.1778L6.99252 16.7087L10.8026 11.1318L15.1245 17.5719L15.5153 18.1543L15.9384 17.595L21.8184 9.82162L22.1204 9.42242L21.9561 9.29839C22.1981 9.2325 22.4354 9.15 22.6663 9.05141Z",
    stroke: "white",
    strokeOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5003 7.33335C22.3413 7.33335 23.8337 5.84097 23.8337 4.00002C23.8337 2.15907 22.3413 0.666687 20.5003 0.666687C18.6594 0.666687 17.167 2.15907 17.167 4.00002C17.167 5.84097 18.6594 7.33335 20.5003 7.33335Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3337 4.00002C23.3337 5.56483 22.0651 6.83335 20.5003 6.83335C18.9355 6.83335 17.667 5.56483 17.667 4.00002C17.667 2.43521 18.9355 1.16669 20.5003 1.16669C22.0651 1.16669 23.3337 2.43521 23.3337 4.00002Z",
    stroke: "white",
    strokeOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1104_2319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkets);
export default __webpack_public_path__ + "static/media/markets.394f3c07d9aee4c66d9e0c97114f6026.svg";
export { ForwardRef as ReactComponent };